import { Controller } from "@hotwired/stimulus"

// Auto-scales text elements to fit their containers.
// Uses ResizeObserver to react to viewport/container size changes.
export default class extends Controller {
  connect() {
    this.scaleAll()
    this.observer = new ResizeObserver(() => {
      requestAnimationFrame(() => this.scaleAll())
    })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }

  scaleAll() {
    this.fitDigits()
    this.fitKpis()
    this.fitTitles()
    this.fitBarValues()
  }

  // Scale odometer digit numbers to fit their .mwc-digit container
  fitDigits() {
    this.element.querySelectorAll('.mwc-digit').forEach(digit => {
      const h = digit.clientHeight
      if (h === 0) return
      // Each digit-number should fill ~75% of the container height
      const fontSize = h * 0.75
      digit.querySelectorAll('.mwc-digit-number').forEach(num => {
        num.style.fontSize = `${fontSize}px`
      })
    })
  }

  // Scale KPI values relative to their quadrant height
  fitKpis() {
    this.element.querySelectorAll('.mwc-kpi-value').forEach(kpi => {
      const quadrant = kpi.closest('.mwc-quadrant')
      if (!quadrant) return
      const h = quadrant.clientHeight
      if (h === 0) return
      // KPI value ~20% of quadrant height
      kpi.style.fontSize = `${h * 0.2}px`
    })
  }

  // Scale bar values to fit within bar width (sized for 4 digits)
  fitBarValues() {
    this.element.querySelectorAll('.mwc-bar').forEach(bar => {
      const value = bar.querySelector('.mwc-bar-value')
      if (!value) return
      const barWidth = bar.clientWidth
      if (barWidth === 0) return
      // Target: 4 digits fit comfortably with some padding
      const fontSize = barWidth / 3.2
      value.style.fontSize = `${Math.max(fontSize, 8)}px`
    })
  }

  // Scale title/subtitle if they overflow the header
  fitTitles() {
    const header = this.element.querySelector('.mwc-header-left')
    if (!header) return
    const maxW = header.clientWidth
    if (maxW === 0) return

    header.querySelectorAll('.mwc-title, .mwc-subtitle').forEach(el => {
      // Reset to CSS value first
      el.style.fontSize = ''
      // If it overflows, shrink until it fits
      let size = parseFloat(getComputedStyle(el).fontSize)
      while (el.scrollWidth > maxW && size > 12) {
        size -= 1
        el.style.fontSize = `${size}px`
      }
    })
  }
}
